import TOGGLE_ALL_USERS from "./toggleAllUsers";
import SET_ALL_USERS from "./setAllUsers";

export default {
    TOGGLE_ALL_USERS,
    SET_ALL_USERS
}